import React from 'react';

/**
 * @typedef {object} PracticeAreaGraphDescriptionProps
 * @property {Object} practiceArea
 * @property {Array<*>} [ohts]
 * @property {Array<*>} [deviceClasses]
 */

/**
 * @param {PracticeAreaGraphDescriptionProps} props
 */
const PracticeAreaGraphDescription = props => {
  const { practiceArea, ohts, deviceClasses } = props;

  const getDeviceClassesString = () => {
    if (!deviceClasses || deviceClasses.length === 0) return '';
    return `${practiceArea.IncludeExactMatchedDeviceClasses ? '*' : ''}Classes: ${deviceClasses.map(
      x => x.displayName
    )}`;
  };

  const getOHTsString = () => {
    if (!ohts || ohts.length === 0) return '';
    return `${practiceArea.IncludeExactMatchedOhts ? '*' : ''}OHTs: ${ohts.map(x =>
      x.displayName.replace('OHT', '')
    )}`;
  };

  return (
    <>
      [
      {[
        practiceArea.Name,
        `PGL ${practiceArea.DefaultLevel}${practiceArea.IncludeHigherLevels ? '+' : ''}`,
        `Year ${practiceArea.Year ? practiceArea.Year : 1}${
          practiceArea.IncludeHigherProgramYears ? '+' : ''
        }`,
        getDeviceClassesString(),
        getOHTsString()
      ]
        .filter(Boolean)
        .join(', ')}
      ]
    </>
  );
};

export default PracticeAreaGraphDescription;
